__turbopack_context__.v({
  "className": "inter_2583ce54-module__KSBUqW__className",
  "variable": "inter_2583ce54-module__KSBUqW__variable",
});
